/**
 * Per-route meta tags. The texts live in src/content/seo.json, where the CMS
 * edits them; this module only gives them their types.
 *
 * Also loaded by scripts/prerender.js at build time. That loader resolves
 * relative imports, so the JSON import above is fine - but a package import
 * (react, @mui, …) would still break the build.
 *
 * The keys mirror RouteDefinition.seoPage in routes.ts. A route pointing at a
 * key that is missing here fails the type check rather than shipping a blank
 * title, which is why SeoPage is derived from the JSON rather than declared.
 */

import seoJson from '../../content/seo.json';
import { Language } from './routes';

export interface SeoEntry {
  title: string;
  description: string;
  keywords?: string;
  type?: 'website' | 'article';
}

/** The pages seo.json covers, as a literal union - used by the SEO component. */
export type SeoPage = keyof typeof seoJson.de;

// The JSON widens `type` to string, so the cast restores the union. Everything
// else lines up structurally and is checked by the assignment.
export const SEO_CONTENT: Record<Language, Record<SeoPage, SeoEntry>> = seoJson as unknown as Record<
  Language,
  Record<SeoPage, SeoEntry>
>;
